<script>
export default {
    beforeRouteEnter( to, from, next){
        // let vm = this
        next( vm =>{
            vm.$router.replace(from.path)
        })
    }
}
</script>